import { _ } from "libs";

import React from "react";
import ClubForm from "./clubForm";
import { Profile } from "../../types";

type Props = {
	profile: Profile;
	onChange: Function;
};

export function Step4({ profile, onChange }: Props) {
	return (
		<div className="box onboardingStep4">
			<div className="boxLeader">
				<h2>{_("onboarding.favoriteClubSection.heading")}</h2>
				<div className="illustration playing_on_fav_court" />
			</div>
			<div className="boxContent">
				<p>{_("onboarding.favoriteClubSection.content")}</p>
				<ClubForm profile={profile} onChange={onChange} />
			</div>
		</div>
	);
}

export default Step4;
